/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactPersonToPointOfSaleV1Dto } from '../models/ContactPersonToPointOfSaleV1Dto';
import type { ContactPersonV1Dto } from '../models/ContactPersonV1Dto';
import type { CreateContactPersonToPointOfSaleV1Dto } from '../models/CreateContactPersonToPointOfSaleV1Dto';
import type { CreateContactPersonV1Dto } from '../models/CreateContactPersonV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { UpdateContactPersonV1Dto } from '../models/UpdateContactPersonV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContactPersonsService {
  /**
   * @param requestBody
   * @returns ContactPersonV1Dto create entity
   * @throws ApiError
   */
  public static contactPersonControllerV1CreateV1(
    requestBody: CreateContactPersonV1Dto,
  ): CancelablePromise<ContactPersonV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/contact-persons',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns ContactPersonV1Dto a entity list
   * @throws ApiError
   */
  public static contactPersonControllerV1FindAllV1(): CancelablePromise<Array<ContactPersonV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contact-persons',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static contactPersonControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contact-persons',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid contactPersonId
   * @returns ContactPersonV1Dto the entity
   * @throws ApiError
   */
  public static contactPersonControllerV1FindOneV1(
    uuid: string,
  ): CancelablePromise<ContactPersonV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contact-persons/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid contactPersonId
   * @param requestBody
   * @returns ContactPersonV1Dto the update entity
   * @throws ApiError
   */
  public static contactPersonControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: UpdateContactPersonV1Dto,
  ): CancelablePromise<ContactPersonV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/contact-persons/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid contactPersonId
   * @returns ContactPersonV1Dto the entity
   * @throws ApiError
   */
  public static contactPersonControllerV1RemoveOneV1(
    uuid: string,
  ): CancelablePromise<ContactPersonV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contact-persons/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid contactPersonId
   * @returns ContactPersonToPointOfSaleV1Dto a entity list
   * @throws ApiError
   */
  public static contactPersonControllerV1FindPointOfSalesV1(
    uuid: string,
  ): CancelablePromise<Array<ContactPersonToPointOfSaleV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contact-persons/{uuid}/point-of-sales',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid contactPersonId
   * @param requestBody
   * @returns ContactPersonToPointOfSaleV1Dto create entity
   * @throws ApiError
   */
  public static contactPersonControllerV1CreatePointOfSaleV1(
    uuid: string,
    requestBody: CreateContactPersonToPointOfSaleV1Dto,
  ): CancelablePromise<ContactPersonToPointOfSaleV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/contact-persons/{uuid}/point-of-sales',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid contactPersonId
   * @param posUuid pointOfSaleId
   * @returns ContactPersonToPointOfSaleV1Dto a entity list
   * @throws ApiError
   */
  public static contactPersonControllerV1FindPointOfSaleLinksV1(
    uuid: string,
    posUuid: string,
  ): CancelablePromise<Array<ContactPersonToPointOfSaleV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contact-persons/{uuid}/point-of-sales/{posUuid}',
      path: {
        uuid: uuid,
        posUuid: posUuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid contactPersonId
   * @param linkUuid
   * @param posUuid contactPersonToPointOfSaleId
   * @returns ContactPersonToPointOfSaleV1Dto the entity
   * @throws ApiError
   */
  public static contactPersonControllerV1RemovePointOfSaleV1(
    uuid: string,
    linkUuid: string,
    posUuid: string,
  ): CancelablePromise<ContactPersonToPointOfSaleV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contact-persons/{uuid}/point-of-sales/{linkUuid}',
      path: {
        uuid: uuid,
        linkUuid: linkUuid,
        posUuid: posUuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
